import { Badge } from "./ui";
import { CheckCircle, AlertTriangle } from "lucide-react";

interface CompletionBadgeProps {
  isComplete: boolean;
  completeText?: string;
  incompleteText?: string;
  size?: "sm" | "md" | "lg";
}

export function CompletionBadge({
  isComplete,
  completeText = "Complete",
  incompleteText = "Incomplete",
  size = "lg",
}: CompletionBadgeProps) {
  return (
    <Badge
      variant={isComplete ? "success" : "error"}
      icon={isComplete ? CheckCircle : AlertTriangle}
      size={size}
    >
      {isComplete ? completeText : incompleteText}
    </Badge>
  );
}
